import {Alert, Button, Card, Form, Spinner} from "react-bootstrap";
import React, {useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import {useAuth} from "../contexts/AuthContext";
import {getUserData} from "../contexts/UsersContext";
import {getAllTests, getAvailableRidesByCity, joinExistingRide} from "../contexts/RidesContext";
import {Typeahead} from "react-bootstrap-typeahead";
import {testsCompareFunction} from "../utils";

export default function JoinRide() {
    const emailRef = useRef()
    const ridesTypeaheadRef = useRef(null);
    const { currentUser } = useAuth()
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const [phoneNumber, setPhoneNumber] = useState("")
    const [address, setAddress] = useState("")
    const [name, setName] = useState("")
    const [selectedRideId, setSelectedRideId] = useState("")
    const [successMessage, setSuccessMessage] = useState("")
    const [tests, setTests] = useState([])
    const [userCity, setUserCity] = useState("")
    const [availableRidesFromCity, setAvailableRidesFromCity] = useState([])
    const [testStringSelection, setTestStringSelection] = useState([])
    const [selectedTestId, setSelectedTestId] = useState(-1)
    const [availableRidesToSelectedTest, setAvailableRidesToSelectedTest] = useState([])
    const [selectedRideString, setSelectedRideString] = useState([])

    useEffect(() => {
        const fetchTests = async () => {
            const testsList = await getAllTests();
            const sortedTestsList = testsList.sort(testsCompareFunction);
            setTests(sortedTestsList);
        }
        const fetchUSerDataAndAvailableRides = async () => {
            const userData = await getUserData(currentUser.email);
            const userFullName = userData.first_name + " " + userData.last_name;
            const userAddress = userData.street + " " + userData.house_number + " " + userData.city;
            const rides = await getAvailableRidesByCity(userData.city);
            setPhoneNumber(userData.phone_number);
            setAddress(userAddress);
            setName(userFullName);
            setUserCity(userData.city);
            setAvailableRidesFromCity(rides);
        };
        fetchTests().catch(console.error);
        fetchUSerDataAndAvailableRides().catch(console.error);
    }, []);

    useEffect(() => {
        const selectedId = testStringSelection.toString() ?  getTestIdFromTestString(testStringSelection.toString()) : -1;
        setSelectedTestId(selectedId);
        // eslint-disable-next-line
    }, [testStringSelection]);

    useEffect(() => {
        const selectedId = selectedRideString.toString() ? getRideIdFromRideString(selectedRideString.toString()) : '';
        setSelectedRideId(selectedId);
        // eslint-disable-next-line
    }, [selectedRideString]);

    useEffect(() => {
       const ridesForTest =  selectedTestId > -1 ? getAvailableRidesForTest(selectedTestId) : [];
       setAvailableRidesToSelectedTest(ridesForTest);
       if (ridesForTest.length === 0) {
           ridesTypeaheadRef.current.clear();
           setSelectedRideId('');
       }
        // eslint-disable-next-line
    }, [selectedTestId]);


    async function handleJoinRide (e) {
        e.preventDefault();
        setLoading(true)
        try {
            await joinExistingRide(selectedRideId, currentUser.uid, address, name, phoneNumber, address);
            setSuccessMessage(`Successfully joined ride! View your rides in home page`)
        } catch (e) {
            console.log(e.message);
            setError("Failed to join drive... Please try again");
        } finally {
            setLoading(false);
        }
    }

    function testString(test) {
        const testData = test.data();
        return `${testData.course_number} ${testData.course_name}, moed ${testData.date_in}`;
    }

    function getTestIdFromTestString(testString) {
        const courseNumber = testString.split(' ')[0];
        const selectedTest = tests.find(test => test.data().course_number === courseNumber);
        return selectedTest.id;
    }

    function getRideIdFromRideString(rideString) {
        const rideIndex = parseInt(rideString.split(' ')[0].substring(1)) - 1;
        return availableRidesFromCity[rideIndex].id;
    }

    function getAvailableRidesForTest(testId) {
        return availableRidesFromCity.filter(ride => ride.test_id === testId);
    }

    function rideString(ride, index) {
        return ride ? `#${index} Available seats: ${ride.available_seats}, Driver: ${ride.driver_first_name} ${ride.driver_last_name}, Leaves from ${userCity} on ${getSelectedTestDate()}` : '';
    }

    function getSelectedTestDate() {
        if (selectedTestId > -1) {
            const selectedTest = tests.find(test => test.id === selectedTestId);
            const selectedTestDate = selectedTest.data().date_time.toDate();
            const yyyy = selectedTestDate.getFullYear();
            let mm = selectedTestDate.getMonth() + 1; // Months start at 0!
            let dd = selectedTestDate.getDate();
            if (dd < 10) dd = '0' + dd;
            if (mm < 10) mm = '0' + mm;
            return dd + '/' + mm + '/' + yyyy;
        }
        return '';
    }

    return (
        <>
            <Card className="text-center" style={{ width: '40rem' }}>
                <Card.Body>
                    <h2 className="text-center mb-4">Join an Existing Ride</h2>
                    <Form onSubmit={handleJoinRide}>
                        <h5>Rides For You to Join</h5>
                        <Form.Group>
                            <Form.Label>Choose a test you want a ride to</Form.Label>
                            <Typeahead
                                id="chooseTest"
                                labelKey="name"
                                onChange={setTestStringSelection}
                                options={tests.map(test => testString(test))}
                                placeholder="Search by course id/name..."
                                selected={testStringSelection}
                            />
                        </Form.Group>
                        <br/>
                        <Form.Group>
                            <Form.Label>Available rides for you to join</Form.Label>
                            <Typeahead
                                id="chooseRide"
                                labelKey="id"
                                options={selectedTestId > -1 && availableRidesToSelectedTest ?
                                    availableRidesToSelectedTest.map(ride => rideString(ride, availableRidesToSelectedTest.indexOf(ride) + 1))
                                    : []}
                                placeholder="Choose test to view available rides..."
                                disabled={selectedTestId < 0}
                                ref={ridesTypeaheadRef}
                                emptyLabel="No available rides for this test :("
                                onChange={setSelectedRideString}
                                selected={selectedRideString}
                            />
                        </Form.Group>
                        <br/>
                        <h5>Passenger Info</h5>
                        <Form.Group id="name">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Your name..."
                                value={name}
                                disabled
                            />
                        </Form.Group>
                        <br/>
                        <Form.Group id="email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                ref={emailRef}
                                required
                                defaultValue={currentUser.email}
                                disabled
                            />
                        </Form.Group>
                        <br></br>
                        <Form.Group id="Phone">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                                type="tel"
                                value={phoneNumber}
                                onChange={e => setPhoneNumber(e.target.value)}
                                disabled
                            />
                        </Form.Group>
                        <br/>
                        <Form.Group id="pickupSpot">
                            <Form.Label>Pickup Location</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Your address..."
                                value={address}
                                onChange={e => setAddress(e.target.value)}
                            />
                        </Form.Group>
                        <br/>

                        <br></br>
                        <Button disabled={loading || !selectedRideId} className="w-100" type="submit">
                            Join Ride
                        </Button>
                        <br/>
                        <br/>
                        {successMessage && <Alert variant='success'>{successMessage}</Alert>}
                        {loading && <Alert variant='info'>Adding you to the ride... Hang tight  <Spinner animation="border"/></Alert>}
                        {error && <Alert variant="danger">{error}</Alert>}
                    </Form>
                </Card.Body>
            </Card>
            <div className="w-100 text-center mt-2">
                <Link to="/">Back</Link>
            </div>
        </>
    )
}